import { Column } from '@devexpress/dx-react-grid';

export const WP_SITE_CONNECTION_REPORT = 'WP Site Connections';

export const WP_SITE_CONNECTIONS_REPORT_MESSAGE =
  'Report showing all connections for WP sites.';

export const WP_SITE_CONNECTION_REPORT_GRID_TITLE = 'wpSiteConnectionsReport';

export const columns: Column[] = [
  { name: 'siteCode', title: 'Site Code' },
  { name: 'capsCodes', title: 'CAPS Codes' },
  { name: 'name', title: 'Name' },
  { name: 'address', title: 'Address' },
  { name: 'postcode', title: 'Postcode' },
  { name: 'systemType', title: 'System Type' },
  { name: 'repairerGroup', title: 'Repairer Group' },
  { name: 'connectionDetails', title: 'Connection Details' },
];

export const tableColumnExtensions = [
  { columnName: 'siteCode', wordWrapEnabled: true },
  { columnName: 'capsCodes', wordWrapEnabled: true },
  { columnName: 'name', wordWrapEnabled: true },
  { columnName: 'address', wordWrapEnabled: true },
  { columnName: 'postcode', wordWrapEnabled: true },
  { columnName: 'systemType', wordWrapEnabled: true },
  { columnName: 'repairerGroup', wordWrapEnabled: true },
  { columnName: 'connectionDetails', wordWrapEnabled: true },
];